import React from 'react';
import { GetSystemResponse } from '../../models/Api';
import { useTranslation } from 'react-i18next';
import './Breadcrumb.scss';

export interface BreadcrumbProps {
  system: GetSystemResponse;
  showSystemProjectsModal: () => void;
}

export const Breadcrumb = (props: BreadcrumbProps) => {
  const { system, showSystemProjectsModal } = props;
  const { t } = useTranslation();
  return (
    <div className="breadcrumb">
      <div className="breadcrumbs-nav">
        <div className="projects" onClick={() => showSystemProjectsModal()}>
          {t('Projects')}
          <span>►</span>
        </div>
        <div className="project-name" onClick={() => showSystemProjectsModal()}>
          {system.projectName}
          <span>►</span>
        </div>
        <div className="system-name">{system.name}</div>
      </div>
    </div>
  );
};
